import { Navigate } from 'react-router';

import CreateEditPaymentRequestPage from '#/modules/finMgmt/claims/pages/CreateEditPaymentRequestPage';
import PaymentRequestDetailPage from '#/modules/finMgmt/claims/pages/PaymentRequestDetailPage';
import PaymentRequestVoucherDetailPage from '#/modules/finMgmt/claims/pages/PaymentRequestVoucherDetailPage';
import CreateEditVoucherPage from '#/modules/finMgmt/vouchers/pages/CreateEditVoucherPage';
import VoucherDetailPage from '#/modules/finMgmt/vouchers/pages/VoucherDetailPage';
import AccountEditPage from '#/modules/infra/pages/AccountEditPage';
import AccountProfilePage from '#/modules/infra/pages/AccountProfilePage';
import AdminHomePage from '#/modules/infra/pages/AdminHomePage';
import {
  RedirectLegacyAccountEdit,
  RedirectLegacyAccountProfile,
  RedirectLegacyClaimEdit,
  RedirectLegacyVoucherEdit,
} from '#/modules/infra/router/routes/admin/personalCenterRedirects';
import {
  FMS_PAYMENT_REQUEST_SELF_CODES,
  FMS_VOUCHER_SELF_CODES,
  PERM,
} from '#/config/permissions';
import { ROUTES } from '#/config/routes';
import RequirePermission from '#/modules/infra/auth/RequirePermission';

export const homeRoutes = [
  {
    index: true,
    handle: { title: '主控台' },
    element: <AdminHomePage />,
  },
  {
    path: 'personal-center',
    handle: { title: '個人中心' },
    children: [
      {
        index: true,
        element: <AccountProfilePage />,
      },
      {
        path: 'edit',
        handle: { title: '修改資料' },
        element: <AccountEditPage />,
      },
      {
        path: 'vouchers',
        handle: {
          title: '我的憑證',
          breadcrumbTo: ROUTES.personalCenterVouchersPanel,
        },
        element: (
          <RequirePermission codes={FMS_VOUCHER_SELF_CODES} mode="any" />
        ),
        children: [
          {
            index: true,
            element: (
              <Navigate to={ROUTES.personalCenterVouchersPanel} replace />
            ),
          },
          {
            path: 'create',
            handle: { title: '新增憑證' },
            element: (
              <RequirePermission code={PERM.FMS_VOUCHER_CREATE}>
                <CreateEditVoucherPage />
              </RequirePermission>
            ),
          },
          {
            path: ':id',
            handle: { title: '憑證詳情' },
            element: <VoucherDetailPage mode="personal" />,
          },
          {
            path: ':id/edit',
            handle: { title: '編輯憑證' },
            element: (
              <RequirePermission code={PERM.FMS_VOUCHER_UPDATE}>
                <CreateEditVoucherPage />
              </RequirePermission>
            ),
          },
        ],
      },
      {
        path: 'claims',
        handle: {
          title: '我的請款',
          breadcrumbTo: ROUTES.personalCenterClaimsPanel,
        },
        element: (
          <RequirePermission codes={FMS_PAYMENT_REQUEST_SELF_CODES} mode="any" />
        ),
        children: [
          {
            index: true,
            element: (
              <Navigate to={ROUTES.personalCenterClaimsPanel} replace />
            ),
          },
          {
            path: 'create',
            handle: { title: '新增請款' },
            element: (
              <RequirePermission code={PERM.FMS_PAYMENT_REQUEST_CREATE}>
                <CreateEditPaymentRequestPage />
              </RequirePermission>
            ),
          },
          {
            path: ':id',
            handle: { title: '請款單詳情' },
            element: <PaymentRequestDetailPage mode="personal" />,
          },
          {
            path: ':id/vouchers/:voucherId',
            handle: { title: '引用憑證' },
            element: <PaymentRequestVoucherDetailPage mode="personal" />,
          },
          {
            path: ':id/edit',
            handle: { title: '編輯請款' },
            element: (
              <RequirePermission code={PERM.FMS_PAYMENT_REQUEST_UPDATE}>
                <CreateEditPaymentRequestPage />
              </RequirePermission>
            ),
          },
        ],
      },
    ],
  },
  // —— 舊 /account/* → personal-center（書籤／深鏈相容）——
  {
    path: 'account/profile',
    element: <RedirectLegacyAccountProfile />,
  },
  {
    path: 'account/edit',
    element: <RedirectLegacyAccountEdit />,
  },
  {
    path: 'account/vouchers/create',
    element: <Navigate to={ROUTES.personalCenterVoucherCreate} replace />,
  },
  {
    path: 'account/vouchers/:id/edit',
    element: <RedirectLegacyVoucherEdit />,
  },
  {
    path: 'account/vouchers',
    element: <Navigate to={ROUTES.personalCenterVouchersPanel} replace />,
  },
  {
    path: 'account/claims/create',
    element: <Navigate to={ROUTES.personalCenterClaimCreate} replace />,
  },
  {
    path: 'account/claims/:id/edit',
    element: <RedirectLegacyClaimEdit />,
  },
  {
    path: 'account/claims',
    element: <Navigate to={ROUTES.personalCenterClaimsPanel} replace />,
  },
];
